export enum AccessType {
	Object = 'Object',
	PermissionSet = 'PermissionSet',
	Profile = 'Profile',
	User = 'User',
}

export enum AccessObjectSource {
	Custom = 'Custom',
	Package = 'Package',
	Standard = 'Standard',
}

export const DataAccessTypePlural = {
	[ AccessType.Object ]: 'Objects',
	[ AccessType.Profile ]: 'Profiles',
	[ AccessType.PermissionSet ]: 'Permission Sets',
	[ AccessType.User ]: 'Users'
};

export enum ObjectPermission {
	create = 'create',
	read = 'read',
	edit = 'edit',
	delete = 'delete',
	viewAllData = 'viewAllData',
	modifyAllData = 'modifyAllData',
}

export enum FieldPermission {
	read = 'read',
	edit = 'edit',
}

export type AccessAuditPermissionRecords = {
	permissions: Partial<Record<ObjectPermission, string>>;
};

export type AccessAuditDetails = AccessAuditPermissionRecords & {
	accessId: string;
	accessName: string;
	accessObjectSource?: AccessObjectSource;
	accessType: AccessType;
	isActive?: boolean;
};

export type AccessObject = {
	name: string;
	type: AccessType,
	sourceUrl?: string;
	userAccessNames?: Array<string>
};

export type ExplainerPermissionRecords = Record<string, Array<string>>;
export type ComparisonPermissionRecords = Record<string, Record<string, string>>;

export type PermissionRecords = {
	permissions: ExplainerPermissionRecords | ComparisonPermissionRecords;
};

export type DataAccessObject = PermissionRecords & {
	objectId: string;
	objectName: string;
};

export type DataAccessField = PermissionRecords &{
	fieldId: string;
	fieldName: string;
	dataSensitivityLevelId: number;
	sonarObjectId: number;
};

export type AccessDetails = {
	accesses: Record<string, AccessObject>;
	objects: Array<DataAccessObject>;
};

export type AccessObjectDetails = {
	accesses: Record<string, AccessObject>;
	fields: Array<DataAccessField>;
};

export type AccessExplainerData = Array<AccessDetails | AccessObjectDetails>;
